import React from 'react';
import { CalendarDays, ArrowRight, AlertTriangle, ChevronRight, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
export function NewsSection() {
  const news = [{
    title: 'Now Hiring Park Rangers for the City of Los Angeles',
    date: '05/01/2026',
    excerpt: 'Make a difference where it matters most by protecting our parks, preserving natural spaces, and serving our communities.',
    image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=600'
  }, {
    title: 'Wildfire Preparedness Workshop',
    date: '04/15/2026',
    excerpt: 'Learn how to protect your home and family. Free workshop for all Sylmar residents.',
    image: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?w=600'
  }, {
    title: 'Community Clean-Up Day Success',
    date: '04/01/2026',
    excerpt: 'Over 100 volunteers joined our spring clean-up event. Thank you Sylmar!',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=600'
  }];
  const quickLinks = ['Agendas & Minutes', 'Agenda Requests', 'Board Meeting Info', 'Committee Schedule', 'Contact Us'];
  return <section className="py-24 px-6 lg:px-8 bg-softblue" data-id="element-250">
      <div className="max-w-7xl mx-auto" data-id="element-251">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-4" data-id="element-252">
          <div data-id="element-253">
            <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-2" data-id="element-254">
              Noticias y Anuncios
            </h2>
            <p className="text-xl text-sylmar font-medium" data-id="element-255">
              News & Announcements
            </p>
          </div>
          <a href="#" className="text-sky hover:text-sky-dark font-bold flex items-center gap-2 transition-colors" data-id="element-256">
            Ver todas las noticias <ArrowRight className="w-4 h-4" data-id="element-257" />
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-258">
          {/* Main Content - News List (3/4 width) */}
          <div className="lg:col-span-3 space-y-6" data-id="element-259">
            {news.map((item, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow border border-gray-100 flex flex-col sm:flex-row group cursor-pointer" data-id="element-260">
                <div className="sm:w-48 h-48 sm:h-auto flex-shrink-0 overflow-hidden relative" data-id="element-261">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-262" />
                </div>
                <div className="p-6 flex flex-col justify-center flex-grow" data-id="element-263">
                  <div className="flex items-center gap-2 text-xs font-bold text-sylmar mb-3" data-id="element-264">
                    <CalendarDays className="w-4 h-4" data-id="element-265" />
                    {item.date}
                  </div>
                  <h3 className="text-xl font-bold text-charcoal mb-3 group-hover:text-sky transition-colors" data-id="element-266">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2" data-id="element-267">
                    {item.excerpt}
                  </p>
                  <span className="text-sylmar font-bold text-sm flex items-center gap-1 group-hover:gap-2 transition-all w-fit" data-id="element-268">
                    Leer más <ArrowRight className="w-4 h-4" data-id="element-269" />
                  </span>
                </div>
              </div>)}
          </div>

          {/* Sidebar (1/4 width) */}
          <div className="lg:col-span-1 space-y-8" data-id="element-270">
            {/* Community Alert Card */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-md border border-red-100" data-id="element-271">
              <div className="h-32 overflow-hidden relative" data-id="element-272">
                <img src="https://images.unsplash.com/photo-1542856391-010fb87dcfed?w=600" alt="Wildfire Alert" className="w-full h-full object-cover" data-id="element-273" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex items-end p-4" data-id="element-274">
                  <div className="flex items-center gap-2 text-white font-bold" data-id="element-275">
                    <AlertTriangle className="w-5 h-5 text-warm" data-id="element-276" />
                    Community Alert
                  </div>
                </div>
              </div>
              <div className="p-5 bg-red-50" data-id="element-277">
                <h4 className="font-bold text-charcoal mb-2" data-id="element-278">
                  Wildfire Season Preparedness
                </h4>
                <p className="text-sm text-gray-700 mb-4" data-id="element-279">
                  Protect your home and family. Review evacuation routes and
                  emergency plans.
                </p>
                <button className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg transition-colors text-sm" data-id="element-280">
                  Learn More
                </button>
              </div>
            </div>

            {/* Quick Links */}
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-281">
              <h4 className="font-bold text-charcoal text-lg mb-4 border-b border-gray-100 pb-2" data-id="element-282">
                Quick Links
              </h4>
              <ul className="space-y-3" data-id="element-283">
                {quickLinks.map((link, index) => <li key={index} data-id="element-284">
                    <a href="#" className="flex items-center justify-between text-gray-600 hover:text-sylmar font-medium text-sm group transition-colors" data-id="element-285">
                      {link}
                      <ChevronRight className="w-4 h-4 text-gray-300 group-hover:text-sylmar transition-colors" data-id="element-286" />
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Connect With Us */}
            <div className="bg-charcoal rounded-2xl p-6 shadow-sm text-white" data-id="element-287">
              <h4 className="font-bold text-white text-lg mb-4" data-id="element-288">
                Connect With Us
              </h4>
              <div className="flex gap-3" data-id="element-289">
                <a href="#" className="bg-charcoal-light hover:bg-sky p-2.5 rounded-lg transition-colors" data-id="element-290">
                  <Facebook className="w-5 h-5" data-id="element-291" />
                </a>
                <a href="#" className="bg-charcoal-light hover:bg-sky p-2.5 rounded-lg transition-colors" data-id="element-292">
                  <Instagram className="w-5 h-5" data-id="element-293" />
                </a>
                <a href="#" className="bg-charcoal-light hover:bg-sky p-2.5 rounded-lg transition-colors" data-id="element-294">
                  <Twitter className="w-5 h-5" data-id="element-295" />
                </a>
                <a href="#" className="bg-charcoal-light hover:bg-red-600 p-2.5 rounded-lg transition-colors" data-id="element-296">
                  <Youtube className="w-5 h-5" data-id="element-297" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}